import React, { lazy, Suspense } from "react";
import SubPageLoading from "views/pages/SubPageLoading";
const CaptionInEditorContext = lazy(() => import("./CaptionInEditorContext"));

export const CaptionInEditorContextLazy = props => (
  <Suspense fallback={<SubPageLoading height={"100vh"} />}>
    <CaptionInEditorContext {...props} />
  </Suspense>
);
CaptionInEditorContextLazy.displayName = "CaptionInEditorContext";

export default CaptionInEditorContextLazy;
